import type { TFunction } from 'i18next';
import type {
  CouponDiscountType,
  CouponStatus,
  CouponType,
  CouponUsageType,
} from '@/generated/root-types';

export const COUPON_TYPES: CouponType[] = ['DURATION', 'FOREVER', 'ONE_TIME'];
export const COUPON_DISCOUNT_TYPES: CouponDiscountType[] = ['FLAT', 'PERCENTAGE'];
export const COUPON_STATUSES: CouponStatus[] = ['ACTIVE', 'INACTIVE'];
export const COUPON_USAGE_TYPES: CouponUsageType[] = ['INTERNAL', 'RESELLER'];

export function couponTypeLabel(t: TFunction, type: string): string {
  const key = `coupons.type.${type}`;
  const translated = t(key);
  return translated === key ? type : translated;
}

export function couponDiscountTypeLabel(t: TFunction, type: string): string {
  const key = `coupons.discountTypeValues.${type}`;
  const translated = t(key);
  return translated === key ? type : translated;
}

export function couponStatusLabel(t: TFunction, status: string): string {
  const key = `coupons.status.${status}`;
  const translated = t(key);
  return translated === key ? status : translated;
}

export function couponUsageTypeLabel(t: TFunction, usageType: string): string {
  const key = `coupons.usageTypeValues.${usageType}`;
  const translated = t(key);
  return translated === key ? usageType : translated;
}

export function formatCouponDiscount(
  t: TFunction,
  discountType: CouponDiscountType,
  discountValue: number,
  locale: string,
): string {
  if (discountType === 'PERCENTAGE') {
    return `${discountValue}%`;
  }
  return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(
    discountValue,
  );
}

export function parseCsvList(value: string): string[] {
  return value
    .split(',')
    .map((x) => x.trim())
    .filter(Boolean);
}

export function joinCsvList(values: string[] | null | undefined): string {
  return (values ?? []).join(', ');
}
